import Vue from 'vue';

// eslint-disable-next-line import/prefer-default-export
export const busEvents = {
  CLOSE_ALL_OTHER_DROPDOWNS: 'CLOSE_ALL_OTHER_DROPDOWNS',
  CLOSE_ALL_OTHER_SUB_DROPDOWNS: 'CLOSE_ALL_OTHER_SUB_DROPDOWNS',
};

export const bus = new Vue();
